import { type AddOnKey } from '@air/api';

import { useWorkspaceAddOns } from '~/hooks/api/useWorkspaceAddOns';

export const useIsAddOnAvailable = ({ key, workspaceId }: { key: AddOnKey; workspaceId: string | undefined }) => {
  const { data: addOns, isPending } = useWorkspaceAddOns({ workspaceId });

  return {
    isAvailable: addOns?.data?.some((addOn) => addOn.key === key && addOn.enabled && addOn.visible),
    isLoading: isPending,
  };
};
